import React, {useEffect, useState} from 'react';
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

import cls from './Index.module.scss'

interface ICountdown {
    startDate: dayjs.Dayjs
}

dayjs.extend(relativeTime)
dayjs.extend(duration)

export const Countdown = ({startDate}: ICountdown) => {

    const [time, setTime] = useState(dayjs());
    useEffect(() => {
        const interval = setInterval(() => setTime(dayjs()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const calcDate = dayjs.duration((startDate.unix() - time.unix()) * 1000)

    return (
        <>
            <div>
                <h2>Начнется через</h2>
                <div className={cls.countdown}>
                    <div className={cls.item}>
                        <div className={cls.value}>{calcDate.format('DD')}</div>
                        <div className={cls.label}>дней</div>
                    </div>
                    <div className={cls.item}>
                        <div className={cls.value}>{calcDate.format('HH')}</div>
                        <div className={cls.label}>часов</div>
                    </div>
                    <div className={cls.item}>
                        <div className={cls.value}>{calcDate.format('mm')}</div>
                        <div className={cls.label}>минут</div>
                    </div>
                    <div className={cls.item}>
                        <div className={cls.value}>{calcDate.format('ss')}</div>
                        <div className={cls.label}>секунд</div>
                    </div>
                </div>
            </div>

            <h2>Совсем скоро! 😲</h2>

        </>
    )
}


